module.exports = __webpack_public_path__ + "static/media/flag_bh.779ef81d.png";